import dayjs from 'dayjs';
import { ITariff } from 'app/shared/model/tariff.model';
import { ITaxTariffTranche } from 'app/shared/model/tax-tariff-tranche.model';
import { IGridOperatorCapacity } from 'app/shared/model/grid-operator-capacity.model';
import { IProductOffering } from 'app/shared/model/product-offering.model';

export interface IProductOfferingPrice {
  id?: number;
  effectiveDate?: dayjs.Dayjs | null;
  expirationDate?: dayjs.Dayjs | null;
  description?: string | null;
  tariffs?: ITariff[];
  taxTariffTranches?: ITaxTariffTranche[];
  gridOperatorCapacities?: IGridOperatorCapacity[];
  productOffering?: IProductOffering | null;
}

export const defaultValue: Readonly<IProductOfferingPrice> = {};
